//
// 	 ###   #  # #####  #          #####  ####  #           ###   #  #  ###   #  # #####
// 	  #    ## #   #    #            #    #     #            #    ## #  #  #  #  #   #
// 	  #    ## #   #    #            #    #     #            #    ## #  #  #  #  #   #
// 	  #    # ##   #    #            #    ###   #            #    # ##  ###   #  #   #
// 	  #    # ##   #    #            #    #     #            #    # ##  #     #  #   #
// 	  #    #  #   #    #            #    #     #            #    #  #  #     #  #   #
// 	 ###   #  #   #    ####         #    ####  ####        ###   #  #  #      ##    #
//
require("intl-tel-input/build/js/utils.js");
window.intlTelInput = require("intl-tel-input/build/js/intlTelInput.js");
require("intl-tel-input/build/css/intlTelInput.css");
window.intlTelInputApply = function() {
	$('input[type="tel"]:not(.intl)').each(function(){

		$(this).attr('type','hidden');

		var field = $('<input type="tel" class="form-control intl" />');
		field.val($(this).val());
		field.data('source',this);

		$(this).after(field)

		var preferredCountries = [
			'fr',
			'gb',
			'us',
			'de',
			'be',
			'nl',
			'es',
			'it',
			'pt',
		].sort(function(a,b){
			if(a.toLowerCase()==ENV_CONFIG.country_code.toLowerCase())
				return -1;
			if(b.toLowerCase()==ENV_CONFIG.country_code.toLowerCase())
				return 1;
			return 0;
		})

		$(field).data('iti',window.intlTelInput(field[0],{
			autoPlaceholder:false,
			preferredCountries:preferredCountries,
			nationalMode:true, // do not require to write prefix
		}))	;

		// on blur: validate
		$(field).on('blur keyup change', function() {
			var iti = $(this).data('iti');
			var source = $(this).data('source');

			if ($(this).val().trim()) {
				if (iti.isValidNumber()) {
					$(this).parents('.form-group').eq(0).removeClass('has-error');
					$(this).removeClass('invalid');
					$(this).addClass('valid');
					iti.setNumber(iti.getNumber());
					$(source).val(iti.getNumber())
				} else {
					$(this).parents('.form-group').eq(0).addClass('has-error');
					$(this).addClass('invalid');
					$(this).removeClass('valid');
				}
			}
		});
	});
}

// add Hapi page cycle refresh event
HAPI_PageCycle.onRefresh(window.intlTelInputApply)